import React from 'react'
import PropTypes from 'prop-types'
import { TouchableOpacity, View, Image, Text } from 'react-native'
import { REACT_NATIVE_S3 } from '../constants'

const baseURL = REACT_NATIVE_S3 + '/images/swatches/'

type SwatchImageProps = {
  /** Identifies the swatch within the group of swatches. */
  keyID: number,
  /** The primary color of the components */
  accentColor: string,
  /** Describes if the swatch is selected */
  selected?: boolean,
  /** The option code for the image to pull */
  option: string,
  /** The onpress callback handler. */
  onSwatchClick: Function,
  /** Text label */
  label: string,
}

/**
 * A product option with a picture. (e.g. a color option).
 * @component
 */
export const SwatchImage = (props: SwatchImageProps) => {
  const onPress = (e: any) => {
    props.onSwatchClick(props.keyID)
  }

  return (
    <View style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 80}}>
    <View
      style={props.selected ? { borderRadius: 42, borderColor: props.accentColor ?? 'dodgerblue', borderWidth: 4, margin: 8 } : {margin: 8}
    }
    >
      <TouchableOpacity
        onPress={onPress}
      >
        <Image
          style={{
            width: props.selected ? 34 : 42, height: props.selected ? 34 : 42,
            borderRadius: props.selected ? 34 : 42,
          }}
          width={props.selected ? 34 : 42}
          height={props.selected ? 34 : 42}
          source={{uri: baseURL + props.option + '.jpg'}}
        />
      </TouchableOpacity>
    </View>
    <Text style={{color: "#4a4a4a"}}>{props.label.replace("Fabric", "")}</Text>
    </View>
  )
}

SwatchImage.propTypes = {
  keyID: PropTypes.number.isRequired,
  accentColor: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  option: PropTypes.string.isRequired,
  onSwatchClick: PropTypes.func.isRequired,
}